import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "medium", "campaign", "output"]

  buildUtm() {
    const parts = []
    const source = this.hasSourceTarget ? this.sourceTarget.value.trim() : ""
    const medium = this.hasMediumTarget ? this.mediumTarget.value.trim() : ""
    const campaign = this.hasCampaignTarget ? this.campaignTarget.value.trim() : ""

    if (source) parts.push(`utm_source=${encodeURIComponent(source)}`)
    if (medium) parts.push(`utm_medium=${encodeURIComponent(medium)}`)
    if (campaign) parts.push(`utm_campaign=${encodeURIComponent(campaign)}`)

    if (this.hasOutputTarget) {
      this.outputTarget.value = parts.join("&")
    }
  }
}
